/**
 * TestimonialCard — quoted card used in the testimonial grid.
 */
import React from 'react';
import { COLOR, FONT, RADIUS, ELEVATION } from '../../../components/ss/tokens';

export default function TestimonialCard({ quote, author, role }) {
  return (
    <figure
      style={{
        background: '#fff',
        border: `1px solid ${COLOR.grayBorder}`,
        borderRadius: RADIUS.lg,
        padding: 28,
        boxShadow: ELEVATION.xs,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 18,
      }}
    >
      <div
        aria-hidden
        style={{
          fontSize: 36,
          lineHeight: 1,
          color: COLOR.blue,
          fontFamily: 'Georgia, serif',
        }}
      >
        “
      </div>
      <blockquote
        style={{
          margin: 0,
          fontSize: 16,
          lineHeight: 1.6,
          color: COLOR.text,
        }}
      >
        {quote}
      </blockquote>
      <figcaption
        style={{
          marginTop: 'auto',
          paddingTop: 14,
          borderTop: `1px solid ${COLOR.graySubtle}`,
        }}
      >
        <div style={{ fontSize: FONT.size.md, fontWeight: FONT.weight.semi, color: COLOR.text }}>
          {author}
        </div>
        {role && (
          <div style={{ fontSize: FONT.size.sm, color: COLOR.textMuted, marginTop: 2 }}>
            {role}
          </div>
        )}
      </figcaption>
    </figure>
  );
}
